// Spin audio — file-based, matching the mobile app exactly.
// Real mobile files can be dropped into /public/assets with the same names.
const MUTE_KEY = "spin_muted";

let music = null;
let tickPool = [];
let tickIdx = 0;
let chime = null;
let lastTick = 0;
let primed = false;

export function isMuted() {
  return localStorage.getItem(MUTE_KEY) === "1";
}
export function setMuted(m) {
  localStorage.setItem(MUTE_KEY, m ? "1" : "0");
  if (m && music) { music.pause(); }
}

// Call inside the Spin click handler (user gesture) to create + prime audio.
export function primeSpinAudio() {
  if (!primed) {
    music = new Audio("/assets/spin_music.mp3");
    music.loop = true;
    music.volume = 0.45;
    tickPool = Array.from({ length: 4 }, () => {
      const a = new Audio("/assets/reel_tick.wav");
      a.volume = 0.95;
      return a;
    });
    chime = new Audio("/assets/win_chime.wav");
    primed = true;
  }
  // prime (unlock) tick instances during the gesture
  tickPool.forEach((a) => { try { a.play().then(() => { a.pause(); a.currentTime = 0; }).catch(() => {}); } catch (e) {} });
}

export function startMusic() {
  if (isMuted() || !music) return;
  try { music.currentTime = 0; music.play().catch(() => {}); } catch (e) {}
}
export function stopMusic() {
  if (music) { try { music.pause(); music.currentTime = 0; } catch (e) {} }
}

export function playTick() {
  if (isMuted() || !tickPool.length) return;
  const now = performance.now();
  if (now - lastTick < 34) return; // throttle
  lastTick = now;
  const a = tickPool[tickIdx];
  tickIdx = (tickIdx + 1) % tickPool.length;
  try { a.currentTime = 0; a.play().catch(() => {}); } catch (e) {}
}

export function playChime() {
  if (isMuted() || !chime) return;
  try { chime.currentTime = 0; chime.play().catch(() => {}); } catch (e) {}
}

export function disposeSpinAudio() {
  stopMusic();
}
